import {
  Bookmark,
  KeyboardArrowRight,
  LightMode,
  ModeComment,
  Nightlight,
  Place,
  ShoppingCart,
  Star,
} from "@mui/icons-material";
import {
  Badge,
  Box,
  Button,
  IconButton,
  Paper,
  Rating,
  Typography,
} from "@mui/material";

import { IStoreDetailData } from "../models";
import { useNavigate } from "react-router-dom";
import CoursePlan, { CoursePlanProps } from "./CousePlan";
import { CSSProperties } from "react";

const plans: CoursePlanProps[] = [
  {
    highlightedName:
      "【ランチコース個室利用】※表示のコース料金に別途、個室利用料が当日お会計に加算されます",
    discountRate: {
      displayable: false,
      value: 0,
    },
    listed_price: 0,
    timeZone: 0,
    popularity: null,
    prices: [
      {
        time: "9:00",
        price: 3300,
      },
      {
        time: "9:30",
        price: 3300,
      },
    ],
  },
  {
    highlightedName:
      "【ランチコース】前菜3品、メイン2品、お口直し、デザート、お茶菓子",
    discountRate: {
      displayable: false,
      value: 0,
    },
    listed_price: 0,
    timeZone: 1,
    popularity: null,
    prices: [
      {
        time: "11:30",
        price: 11858,
      },
      {
        time: "12:00",
        price: 11858,
      },
      {
        time: "12:30",
        price: 11858,
      },
      {
        time: "13:00",
        price: 11858,
      },
    ],
  },
  {
    highlightedName:
      "【ディナーコース】アミューズ4品、前菜3品、メイン2品、チーズ料理、デザート、お茶菓子",
    discountRate: {
      displayable: false,
      value: 0,
    },
    listed_price: 0,
    timeZone: 2,
    popularity: 1,
    prices: [
      {
        time: "18:30",
        price: 21780,
      },
      {
        time: "19:00",
        price: 21780,
      },
      {
        time: "19:30",
        price: 21780,
      },
      {
        time: "20:00",
        price: 21780,
      },
    ],
  },
];

function StoreCard(props: IStoreDetailData & { index: number }) {
  const navigate = useNavigate();

  let badgeColor: CSSProperties = {
    fontSize: "48px",
    color: "#af9b65",
  };

  switch (props.index) {
    case 1:
      badgeColor = {
        ...badgeColor,
        color: "#d6b604",
      };
      break;
    case 2:
      badgeColor = {
        ...badgeColor,
        color: "#777",
      };
      break;
    case 3:
      badgeColor = {
        ...badgeColor,
        color: "#844c00",
      };
      break;
    default:
      break;
  }

  return (
    <Paper
      elevation={1}
      sx={{
        // height: 800,
        marginBottom: 5,
        display: "flex",
        flexDirection: "column",
        width: "100%",
        "&:hover": {
          boxShadow: 3,
        },
      }}
    >
      <Box
        display="flex"
        position="relative"
        width="100%"
        height="250px"
        borderRadius={"5px 5px 0px 0px"}
        sx={{
          "&:hover": {
            cursor: "pointer",
          },
          "&:hover img": {
            transition: ".3s",
            transform: "scale(1.1)",
          },
        }}
        onClick={() => {
          navigate(`/stores/${props.Id}`);
        }}
      >
        <Box
          display="flex"
          position="relative"
          overflow="hidden"
          width="100%"
          height="100%"
          borderRadius={"5px 5px 0px 0px"}
        >
          <img
            src={props.Images[0]}
            alt="Store banner 1"
            style={{
              // borderRadius: 2,
              width: "50%",
              height: "100%",
              objectFit: "cover",
              transition: "transform 0.3s ease",
            }}
          />
          <img
            src={props.Images[1]}
            alt="Store banner 2"
            style={{
              // borderRadius: 2,
              width: "50%",
              height: "100%",
              objectFit: "cover",
              transition: "transform 0.3s ease",
            }}
          />
        </Box>
        <Box
          position="absolute"
          top={0}
          right={0}
          left={0}
          bottom={0}
          display="flex"
          flexDirection="column"
          justifyContent="end"
          padding={2}
          sx={{
            backgroundImage:
              "linear-gradient(to top, rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0), rgba(0, 0, 0, 0))",
          }}
        >
          <Typography variant="h6" color="white" fontWeight="bold">
            {props.Name}
          </Typography>
          <Typography variant="body1" color="white">
            {/* {location} */}
            {props.Area}
          </Typography>
          <Box display="flex" alignItems="center">
            <Rating
              size="small"
              value={props.Points.avg}
              precision={0.5}
              readOnly
              emptyIcon={<Star fontSize="inherit" style={{ color: "white" }} />}
            />
            <Typography
              variant="body1"
              color="white"
              fontWeight="bold"
              sx={{ mx: 1 }}
            >
              {props.Points.avg}
            </Typography>
          </Box>
        </Box>

        <Box position="absolute" top={-10} left={0} height="max-content">
          <Box position="relative" width="100%" height="100%">
            <Bookmark style={badgeColor} />
            <Box
              position="absolute"
              top={0}
              bottom={0}
              left={0}
              right={0}
              display="flex"
              alignItems="center"
              justifyContent="center"
            >
              <Typography color="white" fontWeight="bold">
                {props.index}
              </Typography>
            </Box>
          </Box>
        </Box>
      </Box>

      <Box display="flex" px={3} flexDirection="column">
        <Box display="flex" alignItems="center" my={1}>
          {props.Budgets.day && props.Budgets.day.min && (
            <Box
              display="flex"
              alignItems="center"
              width="max-content"
              py={2}
              marginRight={2}
            >
              <Box
                p={0.5}
                bgcolor="#aaa"
                borderRadius={25}
                marginRight={1}
                display="flex"
                justifyContent="center"
                alignItems="center"
              >
                <LightMode style={{ color: "white", fontSize: "15px" }} />
              </Box>
              <Typography fontWeight="bold">{`￥${props.Budgets.day.min} ~ ￥${props.Budgets.day.max}`}</Typography>
            </Box>
          )}

          {props.Budgets.night && props.Budgets.night.min && (
            <Box display="flex" alignItems="center" width="max-content" py={2}>
              <Box
                p={0.5}
                bgcolor="#aaa"
                borderRadius={25}
                marginRight={1}
                display="flex"
                justifyContent="center"
                alignItems="center"
              >
                <Nightlight style={{ color: "white", fontSize: "15px" }} />
              </Box>
              <Typography fontWeight="bold">{`￥${props.Budgets.night.min} ~ ￥${props.Budgets.night.max}`}</Typography>
            </Box>
          )}
        </Box>

        <Box display="flex" flex={1} width="100%" alignItems="start">
          <Box display="flex" flex={1} paddingRight={4}>
            <Typography variant="body1">{props.Intro}</Typography>
          </Box>
          <Box
            display="flex"
            border={1}
            borderRadius={2}
            py={1}
            px={2}
            sx={{
              cursor: "pointer",
              transition: "color 0.3s ease-in-out",
              "&:hover": {
                color: "primary.main",
              },
            }}
          >
            <Place fontSize="small" />
          </Box>
        </Box>

        {plans.map((e) => (
          <CoursePlan {...e} />
        ))}

        {plans.length > 0 && (
          <Box display="flex" justifyContent="end" alignItems="center" my={1}>
            <Button endIcon={<KeyboardArrowRight />}>
              すべてのプランをみる
            </Button>
          </Box>
        )}
      </Box>
    </Paper>
  );
}

export default StoreCard;
